/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { TypePolicies } from '@apollo/client';
import {
  ListMachinesByUserQueryVariables,
  ListMachinesQueryVariables,
} from '../graphql/generated';
import { cacheMergePaginatedList } from './cache.util';

const MachineCacheTypePolicies: TypePolicies = {
  Query: {
    fields: {
      listMachines: {
        keyArgs: ['input', ['teamId', 'active']],
        merge: (existing, incoming, { variables }) => {
          return cacheMergePaginatedList<ListMachinesQueryVariables>(
            existing,
            incoming,
            variables as ListMachinesQueryVariables
          );
        },
      },
      listMachinesByUser: {
        keyArgs: ['input', ['active']],
        merge: (existing, incoming, { variables }) => {
          return cacheMergePaginatedList<ListMachinesByUserQueryVariables>(
            existing,
            incoming,
            variables as ListMachinesByUserQueryVariables
          );
        },
      },
    },
  },
  MachineState: {
    keyFields: ['machineId'],
  },
  Machine: {
    fields: {},
  },
  Subscription: {
    fields: {
      subscribeToMachineState: {
        merge: false,
      },
      subscribeToSingleMachineState: {
        merge: false,
      },
    },
  },
};

export { MachineCacheTypePolicies };
